import { useEffect, useCallback } from "react";
import { useAppStore } from "@/stores/appStore";

interface GoogleSignInButtonProps {
  handleGoogleSignInCallback: (response: any) => void;
}

export const GoogleSignInButton = ({
  handleGoogleSignInCallback,
}: GoogleSignInButtonProps) => {
  const { effectiveTheme } = useAppStore();
  const handleSignInWithGoogle = useCallback(
    async (response: any) => {
      handleGoogleSignInCallback(response);
    },
    [handleGoogleSignInCallback]
  );

  useEffect(() => {
    // Make the callback function globally accessible
    (window as any).handleSignInWithGoogle = handleSignInWithGoogle;

    // Initialize Google Sign-In when the script is loaded
    const initializeGoogleSignIn = () => {
      if ((window as any).google) {
        try {
          (window as any).google.accounts.id.initialize({
            client_id:
              "2250807774-56e116b602brk82t92kvg7m009sk3h4r.apps.googleusercontent.com",
            callback: handleSignInWithGoogle,
            color_scheme: effectiveTheme,
            auto_select: true,
            cancel_on_tap_outside: true,
            context: "signin",
            button_auto_select: true,
          });

          // Render the button
          (window as any).google.accounts.id.renderButton(
            document.getElementById("google-signin-button"),
            {
              type: "standard",
              shape: "rectangular",
              theme: "outline",
              text: "signin_with",
              size: "medium",
              logo_alignment: "left",
            }
          );

          // Show the One Tap prompt
          //   (window as any).google.accounts.id.prompt();
        } catch (error) {
          console.error("Error initializing Google Sign-In:", error);
        }
      }
    };

    // Check if Google script is already loaded
    if ((window as any).google) {
      initializeGoogleSignIn();
    } else {
      // Wait for the script to load
      const checkGoogleLoaded = setInterval(() => {
        if ((window as any).google) {
          clearInterval(checkGoogleLoaded);
          initializeGoogleSignIn();
        }
      }, 100);

      // Cleanup interval after 10 seconds
      setTimeout(() => clearInterval(checkGoogleLoaded), 10000);
    }

    // Cleanup function
    return () => {
      delete (window as any).handleSignInWithGoogle;
    };
  }, [handleSignInWithGoogle]);

  return <div id="google-signin-button" className="flex justify-center"></div>;
};
